import { render, staticRenderFns } from "./Relais.vue?vue&type=template&id=8166b88e&"
import script from "./Relais.vue?vue&type=script&lang=js&"
export * from "./Relais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports